import { Buffer } from 'buffer';
import { toRaw } from 'microphone-stream';
import { when } from 'ramda';
import { createPipe, pipe } from 'remeda';
import { EventStreamMarshaller } from '@aws-sdk/eventstream-marshaller';
import { fromUtf8, toUtf8 } from '@aws-sdk/util-utf8-node';
import { getAudioEventMessage } from './awsV4';

const inputSampleRate = 44100;

const eventStreamMarshaller = new EventStreamMarshaller(toUtf8, fromUtf8);

export function pcmEncode(input: Float32Array) {
  let offset = 0;
  const buffer = new ArrayBuffer(input.length * 2);
  const view = new DataView(buffer);
  for (let i = 0; i < input.length; i++, offset += 2) {
    const s = Math.max(-1, Math.min(1, input[i]));
    view.setInt16(offset, s < 0 ? s * 0x8000 : s * 0x7FFF, true);
  }
  return buffer;
}

export function downsampleBuffer({ buffer, outputSampleRate = 16000 }: { buffer: Float32Array, outputSampleRate: number }) {
  if (outputSampleRate === inputSampleRate) {
    return buffer;
  }

  const sampleRateRatio = inputSampleRate / outputSampleRate;
  const newLength = Math.round(buffer.length / sampleRateRatio);
  const result = new Float32Array(newLength);
  let offsetResult = 0;
  let offsetBuffer = 0;
  while (offsetResult < result.length) {
    const nextOffsetBuffer = Math.round((offsetResult + 1) * sampleRateRatio);
    let accum = 0;
    let count = 0;
    for (let i = offsetBuffer; i < nextOffsetBuffer && i < buffer.length; i++) {
      accum += buffer[i];
      count++;
    }
    result[offsetResult] = accum / count;
    offsetResult++;
    offsetBuffer = nextOffsetBuffer;
  }
  return result;
}

export function convertAudioToBinaryMessage(audioChunk: Buffer, sampleRate: number): Uint8Array {
  return pipe(
    audioChunk,
    when<Uint8Array, Uint8Array>(Boolean, createPipe(
      toRaw,
      // downsample and convert the raw audio bytes to PCM
      (buffer: Float32Array) => downsampleBuffer({ buffer, outputSampleRate: sampleRate }),
      pcmEncode,
      // @ts-ignore
      Buffer,
      // add the right JSON headers and structure to the message
      getAudioEventMessage,
      // convert the JSON object + headers into a binary event stream message
      eventStreamMarshaller.marshall.bind(eventStreamMarshaller),
    )),
  );
}

